
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);


//   document.querySelectorAll(".hero-v1").forEach((hero) => {
//     gsap.to(hero.querySelector("img"), {
//       yPercent: 40, // Modifica la percentuale per controllare la velocità del parallasse
//       ease: "none",
//       scrollTrigger: {
//         trigger: hero,
//         start: "top bottom", // Inizio dell'effetto di parallasse
//         end: "bottom top",   // Fine dell'effetto di parallasse
//         scrub: true,         // Sincronizza l'animazione con lo scroll
//         invalidateOnRefresh: true
//       }
//     });
//   });